var path = 'components/vods/tooltips/vodsNetworksNames.html';
var html = "<div ng-repeat=\"name in vod._networksNames() | orderBy track by $index\" ng-bind=name /> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;